import router from '@/router/index';
import productService from '@/api/productConfigService'

const state = {

    products: [],
    newProduct: '',
    editId: null,
    auditLogs: [],
    totalAuditLogs: 0
}
const getters = {
    productList: state => state.products,
    product: state=> state.newProduct
};

const actions = {
    async addProduct({ commit }, product) {
        await productService.addProduct(product)
        commit('addProducts', product, {root: true})
    },
    async editProduct({ commit }, product) {
        const response = await productService.getPrductById(product.id)
        commit('edit', response.data)
    },
    async updateProduct({commit }, product) {
        await productService.updateProduct(product.id, product)
        commit('updateProduct', product, {root: true})
    },
    async removeProduct({ commit }, product) {
        await productService.removeProduct(product.id)
        commit('removeProduct', product, {root: true})
    },
    async getAuditLogs({commit}, data){
        let auditLog = await productService.getAuditLogs(data.productId, data.pageSize, data.pageNo);
        if(auditLog.status == 200){
            commit('setAuditLog', auditLog.data.result)
            commit('setTotalAuditLogs', auditLog.data.totalDataCount);
        }
    },
}
const mutations={    
    edit(state, product) { 
        state.editId = product.code
        state.newProduct = product
        router.push({name: "AddProduct", params: {add: false }});
    },
    setAuditLog(state, data){
        state.auditLogs = data;
    },
    setTotalAuditLogs(state, data){
        state.totalAuditLogs = data;
    }
}

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}